// utils/getValidToken.js
import { supabase } from "../supabaseClient";

export async function getValidToken() {
  let token = localStorage.getItem("token");
  let userId = localStorage.getItem("userId");

  const {
    data: { session },
    error: sessionError,
  } = await supabase.auth.getSession();

  if (sessionError) console.error("Session fetch error:", sessionError);

  // 🔁 Refresh if missing or expired
  if (!session || !session.access_token) {
    console.log("🔁 Session missing/expired, refreshing...");
    const { data: refreshed, error: refreshError } =
      await supabase.auth.refreshSession();

    if (refreshError) throw new Error("Session expired. Please log in again.");

    token = refreshed.session.access_token;
    userId = refreshed.session.user.id;
    localStorage.setItem("token", token);
    localStorage.setItem("userId", userId);
  } else {
    token = session.access_token;
    userId = session.user.id;
  }

  return { token, userId };
}
